import { get } from './';

export const getCitiesByCountry = ({ countryId }) =>
  get(`/api/v1/cities/${countryId}`);
